import React, {useState} from 'react'
import {Stack, Divider, Grid, FormControlLabel, Link} from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import WbCheckbox from '../../../components/common/WbCheckbox'
import WbButton from '../../../components/common/WbButton'
import TemplatePreview from './TemplatePreview'

export default function SurveyBlock({survey, setSurveyIds, surveyIds}) {
  const [previewing, setPreviewing] = useState(false)
  return (
    <Grid item lg={4} md={4} sm={6} xs={12}>
      <div className="checkin-survey-block selected-survey-block">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <div className="surveyname">{survey?.name}</div>
          <FormControlLabel
            control={
              <WbCheckbox
                sx={{padding: 0}}
                checked={surveyIds.findIndex(s => s.id === survey?.id) > -1}
                onChange={e => {
                  if (e.target.checked) {
                    setSurveyIds([...surveyIds, survey])
                  } else {
                    setSurveyIds(surveyIds.filter(s => s.id !== survey?.id))
                  }
                }}
              />
            }
            label=""
            sx={{margin: 0}}
          />
        </Stack>
        <Divider orientation="horizontal" />
        <Stack direction="column" mt={2} rowGap={1}>
          <div className="frequency">
            <HelpOutlineIcon sx={{fontSize: '20px'}} />
            <div>
              Total No of Questions:{' '}
              <strong>{survey?.surveyQuestions?.length}</strong>
            </div>
          </div>
          <div className="meta-text">
            <WbButton
              CustomButtonText="Preview Questions"            
              onClick={() => setPreviewing(true)}
              sx={{            
                fontSize: '14px',                                
                backgroundColor: '#007A7A',
                borderColor: '#007A7A',
                color: '#fff',
                marginTop: '15px'            
              }}
            />          
          </div>
        </Stack>
      </div>
      {previewing && (
        <TemplatePreview template={survey} onClose={() => setPreviewing(false)} />
      )}
    </Grid>
  )
}
